module.exports = __webpack_public_path__ + "static/img/Frame 18214.b0c971d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper3/Frame 18214.png
// module id = d5an
// module chunks = 13